/**
* @name: right-menu-detail
* @author: weiyong
* @date: 2023-05-14 17:54
* @description：right-menu-detail
* @update: 2023-05-14 17:54
*/
<template>
  <div class="console-base-pane-main expandMenu h100b"
       :class="prefixCls,[menuProps.showMenu?'open-menu':'close-menu']">

    <div class="col-btn-div" @click.stop="closePanel" style="z-index: 300">
      <close-outlined/>
    </div>
    <div class="content flex-div-bet h100b">
      <div class="left-area-div">
        <div class="w100b" style="padding: 6px 12px;">
          <a-input v-model:value="searchMenuKey" :bordered="false"
                   @pressEnter="searchMenuFun"
                   @change="changInput"
                   :allowClear="true"
                   style="border-bottom: 1px solid #eee" placeholder="输入菜单名称查询">
            <template #prefix>
              <search-outlined @click="searchMenuFun" type="user"/>
            </template>
          </a-input>
        </div>

        <div class="menu-body" style="width: 600px">
          <div class="products-recent" style="padding: 0 12px">
            <h4 class="app-name">{{ searchMenuList.length === 0 ? '最近访问' : '搜索结果' }}</h4>
            <div v-if="searchMenuList.length===0">
              <user-recent-menu-list :collectMenuList="menuList"/>
            </div>
            <div v-else>
              <user-sear-menu-list :collectMenuList="menuList"
                                   :menuList="searchMenuList"></user-sear-menu-list>
            </div>
          </div>

          <div class="split-div"></div>

          <div class="menu-content-list">

            <div class="w100b menu-group-title">
              <h3 class="group-title">{{ menuProps.mainMenu.label || menuProps.mainMenu.name }}</h3>
            </div>

            <div class="sub-menus-group w100b" v-for="item in menuProps.subMenus"
                 :class="item.children&&item.children.length>0?'sub-item':'common-item'">

              <div class="tow-sub-menus" v-if="item.children&&item.children.length>0">
                <div class="sub-menu-group-title w100b">
                  <h3 class="group-title">{{ item.label || item.name }}</h3>
                </div>

                <div class="w100b sub-menu-bodys flex-div">
                  <menu-li-record @collectMenuClick="collectMenu"
                                  :isCollectItemFlag="isCollectItem(sonItem)"
                                  @click="openMenu(sonItem)" class="common-menu-li" :item="sonItem"
                                  v-for="sonItem in item.children"/>
                </div>
                <a-divider/>
              </div>

              <div v-else class="common-menu-li w100b">
                <menu-li-record @collectMenuClick="collectMenu"
                                :isCollectItemFlag="isCollectItem(item)" @click="openMenu(item)"
                                :item="item"/>
              </div>
            </div>

          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

export default defineComponent({
  components: {},
  name: "right-menu-detail",
});
</script>

<script lang="ts" setup>
import UserSearMenuList from "@/layouts/layoutFrame/military/components/user-sear-menu-list.vue";
import MenuLiRecord from "@/layouts/layoutFrame/military/components/menu-li-record.vue";
import {Divider as ADivider} from 'ant-design-vue';
import UserRecentMenuList
  from "@/layouts/layoutFrame/military/components/user-recent-menu-list.vue";
import {SearchOutlined, CloseOutlined} from "@ant-design/icons-vue";
import {useDesign} from "@/hooks/web/useDesign";
import {useMenuStore} from "@/layouts/layoutFrame/military/viewStore/menuStore";
import {useRouter} from "vue-router";
import {useI18n} from "@/hooks/web/useI18n";
import {useMenuHooks} from "@/layouts/layoutFrame/hooks/useMenuHooks";
import {useCollectMenus} from "@/layouts/layoutFrame/hooks/useCollectMenus";
import {useMenuSearchHooks} from "@/layouts/layoutFrame/military/hooks/useMenuSearchHooks";

const {prefixCls} = useDesign('military-right-menu-detail');

const menuStore = useMenuStore();
const {
  activeMenuId,
  menuProps
}: any = storeToRefs(menuStore)

const {
  searchMenuList,
  changInput,
  searchMenuKey,
  searchMenuFun
} = useMenuSearchHooks();

const router = useRouter();
const {t} = useI18n();
const {
  menuClick
} = useMenuHooks(router, t);
/**
 * 关闭菜单panel
 */
const closePanel = function () {
  unref(menuProps).showMenu = false;
}
const openMenu = function (item) {
  activeMenuId.value = item.id;
  menuClick({key: item.path,menuId:item.id}, unref(menuProps).menusAll);
  closePanel();
}


const menuList: any = ref([]);
onMounted(() => {
  getCollectMenus(flushList);
})


const flushList = function (list) {
  if (list && Array.isArray(list)) {
    menuList.value = list;
  }
}

const {collectMenu, getCollectMenus, spinning} = useCollectMenus(flushList);

//判断是否已经收藏的菜单
const isCollectItem = (item) => {
  if (unref(menuList) && unref(menuList).length > 0) {
    const colItem = unref(menuList).filter((itemDb) => {
      return item.id === itemDb.id;
    })[0];
    if (colItem) {
      return true
    }
  }
  return false
}

</script>

<style type="text/css" lang="less">
@prefix-cls: ~'@{namespace}-military-right-menu-detail';

.@{prefix-cls} {
  position: relative;
  --common-base-padding: 12px;
  --header-bar-bg-color: #eee;
  box-shadow: 0 50px 100px -12px #0000001a, 0 30px 60px -30px #00000026;

  .content {
    .ant-input-affix-wrapper:focus {
      border: 0;
    }
  }

  .sub-menu-group-title {
    padding: 8px 0;

    h3 {
      margin: 0;
    }

    .group-title {
      position: relative;
      padding-left: 6px;

      &:before {
        content: ' ';
        position: absolute;
        width: 3px;
        background-color: var(--primary-color, #0a6eff);
        left: -4px;
        top: 3px;
        height: 13px;
      }
    }
  }

  .ant-divider-horizontal {
    margin: 8px 0;
  }

  .menu-group-title {
    padding: 8px var(--common-base-padding, 12px);
    font-size: 16px;

    font-weight: 500;
    background-color: var(--header-bar-bg-color, #eee);
    display: flex;
    align-items: center;

    h3 {
      margin: 0;
    }
  }

  .menu-content-list {
    display: flex;
    flex-wrap: wrap;

    .sub-menus-group {
      width: 33.33%;
      margin-bottom: 2px;
      padding: 0 16px;

      &.sub-item {
        width: 100%;
      }

      .tow-sub-menus {
        .sub-menu-bodys {
          flex-wrap: wrap;

          .common-menu-li {
            width: 30.33%;
            margin-right: 12px;
            margin-bottom: 6px;
          }
        }
      }
    }


    .common-menu-li {
      cursor: pointer;
      display: flex;
      align-items: center;
      height: 38px;

      .icon-div {
        position: relative;
        top: -1px;
      }

      &:hover {
        color: var(--primary-color, #eee);

        i {
          color: var(--primary-color, #eee);
        }
      }
    }
  }

  .menu-body {
    height: calc(100% - 90px);
    overflow: auto;

    .sc-CB-cTQhss {
      height: calc(100% - 220px);
    }

    .son-item-li {
      display: block;
      border-width: 1px;
      border-style: solid;
      border-image: initial;
      border-radius: 2px;
      width: 100%;
      max-width: 100%;
      cursor: pointer;
      vertical-align: middle;
      text-align: left;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--cb-color-button-tertiary-text, #666);
      background-color: var(--cb-color-button-tertiary-bg, transparent);
      border-color: var(--cb-color-button-tertiary-border, transparent);
      padding: 0px 12px;
      height: 32px;
      line-height: 30px;
      font-size: var(--base-font-size, 14px)
    }

    .app-name {
      margin: 0px;
      padding: 0px 8px;
      height: 32px;
      line-height: 32px;
      font-weight: 600;
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
      color: var(--cb-color-text-primary, #333);
    }

    .split-div {
      height: 24px;
      color: var(--cb-color-text-disabled, #c0c6cc);
    }

    .menu-content-list {
      margin-bottom: 12px;
    }

    .CB-hMMMA-D {
      column-gap: 12px;
    }
  }

  .left-area-div {
    flex: 1;
    height: 100%;
    padding: 0;
    padding-top: 20px;
  }

  .right-area-div {
    width: 160px;
    padding: 0;
    padding-top: 60px;
    height: 100%;
  }

  .col-btn-div {
    right: 12px;
    top: 10px;
    position: absolute;
    font-size: 18px;
    color: #666;
    cursor: pointer;
  }

  .ant-input-affix-wrapper-focused {
    border: 0;
    box-shadow: none;
  }
}
</style>
